
import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import { Button, InputGroup } from "@blueprintjs/core";
import axios from "axios";
import Cookies from "js-cookie";

const GoalProgressStatusManager = forwardRef(({ goalSettingId }, ref) => {
  const [statusList, setStatusList] = useState([]);
  const [newStatus, setNewStatus] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);
  const [editedValue, setEditedValue] = useState("");
  const [customStatuses, setCustomStatuses] = useState([]);

  const dummyStatusList = [
    { id: 1, status_name: "Draft", is_default: 1 },
    { id: 2, status_name: "Pending", is_default: 1 },
    { id: 3, status_name: "Complete", is_default: 1 },
    { id: 4, status_name: "Approved", is_default: 1 },
    { id: 5, status_name: "Rejected", is_default: 1 }
  ];
  
  const displayStatusList = goalSettingId
  ? statusList
  : [...dummyStatusList, ...customStatuses];
  

  useEffect(() => {
    if (goalSettingId) {
      axios
        .get(`${Cookies.get("apiEnv")}/goal_progress_states?goal_setting_id=${goalSettingId}`)
        .then(res => {
          setStatusList(Array.isArray(res.data) ? res.data : []);
        })
        .catch(err => {
          console.error("Error fetching goal progress states", err);
          setStatusList([]);
        });
    } else {
      // Do not update statusList used for saving — only show dummy data
      setStatusList([]); 
    }
  }, [goalSettingId]);
  
  
  const handleAddStatus = () => {
    const trimmed = newStatus.trim();
    if (!trimmed) return;

    const formatted = capitalizeFirstLetters(trimmed);

  
    if (goalSettingId) {
      setStatusList(prev => [...prev, { status_name: formatted }]);
    } else {
      setCustomStatuses(prev => [...prev, { status_name: formatted, is_default: 0 }]);
    }
  
    setNewStatus("");
  };
  
  const handleDeleteStatus = index => {
    if (goalSettingId) {
      setStatusList(prev => prev.filter((_, i) => i !== index));
    } else {
      // Adjust index for custom statuses (dummy statuses come first)
      const adjustedIndex = index - dummyStatusList.length;
      setCustomStatuses(prev => prev.filter((_, i) => i !== adjustedIndex));
    }
  };
  
  const handleEditSave = () => {
    const trimmed = editedValue.trim();
    if (!trimmed) return;
  
    if (goalSettingId) {
      setStatusList(prev =>
        prev.map((item, i) =>
          i === editingIndex ? { ...item, status_name: trimmed } : item
        )
      );
    } else {
      setCustomStatuses(prev =>
        prev.map((item, i) =>
          i === editingIndex - dummyStatusList.length ? { ...item, status_name: trimmed } : item
        )
      );
    }
  
    setEditingIndex(null);
    setEditedValue("");
  };
  

  useImperativeHandle(ref, () => ({
    getStatusList: () => {
      return goalSettingId ? statusList : customStatuses;
    }
  }));

  const capitalizeFirstLetters = (str) =>
    str.replace(/\b\w/g, char => char.toUpperCase());
  
  
  

  return (
    <div style={{ marginTop: "1rem" }}>

      <div style={{ display: "flex", gap: "8px", marginBottom: "12px" }}>
        <InputGroup
          placeholder="Enter status name"
          value={newStatus}
          onChange={e => setNewStatus(e.target.value)}
          onKeyDown={e => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleAddStatus();
            }
          }}
         // onKeyDown={e => e.key === "Enter" && handleAddStatus()}
          style={{ flexGrow: 1, maxWidth: 300 }}
        />
        <Button onClick={handleAddStatus} intent="primary" icon="plus" style={{ backgroundColor: "#1870d5" }}>
          Add
        </Button>
      </div>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
      {displayStatusList.map((status, index) =>
  editingIndex === index ? (
    <div
      key={index}
      style={{ display: "flex", alignItems: "center", gap: 6 ,paddingLeft:'10px'}}
    >
      <InputGroup
        value={editedValue}
        onChange={e => setEditedValue(e.target.value)}
        onKeyDown={e => {
          if (e.key === "Enter") handleEditSave();
        }}
        autoFocus
        style={{ minWidth: 120 }}
      />
      <Button
        minimal
        icon="tick"
        intent="success"
        onClick={handleEditSave}
        title="Save"
        style={{ padding: 4 }}
      />
    </div>
  ) : (
    <div
      key={index}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        border: "1px solid #d6d6d6",
        borderRadius: '22px',
        padding: "5px 20px",
        cursor: "pointer",
        userSelect: "none",
       // boxShadow: "0 1px 3px rgb(0 0 0 / 0.1)",
      }}
      onMouseEnter={e => {
       // e.currentTarget.style.backgroundColor = "#e0eaff";
        e.currentTarget.style.borderColor = "#007bff";
      }}
      onMouseLeave={e => {
       // e.currentTarget.style.backgroundColor = "#f5f5f5";
        e.currentTarget.style.borderColor = "#ccc";
      }}
    >
      <span style={{ flexGrow: 1, fontSize: 14 }}>{status.status_name}</span>

      {status.is_default !== 1 && (
        <>
          <Button
            minimal
            icon="edit"
            intent="primary"
            onClick={() => {
              setEditingIndex(index);
              setEditedValue(status.status_name);
            }}
            title="Edit"
            style={{ padding: 4 }}
          />
          <Button
            minimal
            icon="cross"
            intent="danger"
            onClick={() => handleDeleteStatus(index)}
            title="Delete"
            style={{ padding: 4 }}
          />
        </>
      )}
    </div>
  )
)}

      </div>
    </div>
  );
});

export default GoalProgressStatusManager;
